module.exports = __webpack_public_path__ + "static/media/mic-32px.d038a53a.svg";